<template>
  <div>
    <v-data-table
      style="width: 100%"
      :loading="loading"
      :headers="headers"
      :items="driverPhotos"
      :options.sync="pagination"
      :server-items-length="serverItemsLength"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 7%">{{ props.item.driver.user.name }}</td>
          <td style="width: 7%">
            <a
              v-on:click.stop="doNothing()"
              :href="
                'tel:' + formatNumber(props.item.driver.user.contact_number)
              "
              >{{ props.item.driver.user.contact_number }}</a
            >
          </td>
          <td style="width: 10%">
            <a
              v-on:click.stop="doNothing()"
              :href="'mailto:' + props.item.driver.user.email"
              >{{ props.item.driver.user.email }}</a
            >
          </td>
          <td style="width: 10%">
            {{
              props.item.taxi.colour +
              " " +
              props.item.taxi.make +
              " " +
              props.item.taxi.model
            }}
          </td>

          <td style="width: 5%">
            {{ props.item.taxi.registration_number }}
          </td>

          <td style="width: 5%">
            {{ props.item.state }}
          </td>

          <td style="width: 5%">
            <v-btn @click="viewPhotos(props.item)" x-small style="">View</v-btn>
          </td>
        </tr>
      </template>

    </v-data-table>
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }"> </template>

      <v-card v-if="dialog == true && selectedItem != null">
        <v-card-title class="headline grey lighten-2"> Photos </v-card-title>
        
        <v-col>
          <v-row class="flex-nowrap">  
            <img style="width: 50%" :src="selectedItem.front_image"></img>

            <img style="width: 50%" :src="selectedItem.back_image"></img>

          </v-row>

           <v-row class="flex-nowrap">  
            <img style="width: 50%"  :src="selectedItem.left_image"></img>

            <img style="width: 50%"  :src="selectedItem.right_image"></img>
          </v-row>
        
          <v-row class="flex-nowrap">

            <img style="width: 50%"  :src="selectedItem.interior_front_image"></img>

            <img style="width: 50%"  :src="selectedItem.interior_back_image"></img>
          </v-row>
        </v-col>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="green" text @click="acceptDailyPhotos">Accept</v-btn>
          <v-btn color="red" text @click="rejectDailyPhotos">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {replaceStart} from "@/components/util/PhoneNumbers.js";
import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";

axios.defaults.withCredentials = true;

export default {
  name: "driver_summary_list",
  components: {
    AttributesForTaxiCell,
  },
  props: {
    query: Object,
  },
  data: function () {
    return {
      serverItemsLength: null,
      selectedItem: null,
      dialog: false,
      rideTypes: [],
      pagination: {},
      driverPhotos: [],
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Contact Number",
          align: "left",
          sortable: false,
          value: "contact_number",
        },
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email",
        },
        {
          text: "Vehicle",
          align: "left",
          sortable: false,
          value: "capabilities",
        },
        {
          text: "REG",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Verified",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Actions",
          align: "left",
          sortable: false,
          value: "taxi",
        },
      ],
      loading: true,
    };
  },
  mounted: async function () {
    console.log("MOUNTED");
    this.getPhotoEntries();
  },
  computed: {},
  watch: {
    pagination: {
      handler() {
        this.getPhotoEntries();
      },
      deep: true,
    },
  },
  methods: {
    refresh() {
      this.getPhotoEntries();
    },
    clearAndRefresh() {
      this.pagination.page = 1;
      this.getPhotoEntries();
    },
    getPhotoEntries: async function () {
      this.loading = true;

      const { page, itemsPerPage } = this.pagination;

      console.log("Pagination " + JSON.stringify(this.pagination));

      try {
        var url = `${this.$store.state.apiUrl}/taxi_photo/list?offset=${
          itemsPerPage * (page - 1)
        }&count=${itemsPerPage}`;

        url += `&filter=${this.query.filter}`;

        url += `&searchQuery=${this.query.searchQuery}`;

        console.log(url);

        let response = await axios.get(url, {
          params: {},
        });

        this.driverPhotos = response.data.taxi_photo_uploads;

        this.serverItemsLength = response.data.pages.total;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get photos " + error);
      }
    },
    acceptDailyPhotos: function () {
      this.updatePhotoUpload(false, "verified");
    },
    rejectDailyPhotos: function () {
      this.updatePhotoUpload(true, "rejected");
    },
    updatePhotoUpload: async function (flagged, state) {
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/taxi_photo/${this.selectedItem.id}/update?flagged=${flagged}&manuallyVerified=true&state=${state}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        if (response.data.error == "no_error") {
          this.$emit("refresh");
          this.dialog = false;
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    viewPhotos: function (selectedItem) {
      console.log("View Photos");

      this.dialog = false;
      this.selectedItem = selectedItem;
      this.dialog = true;
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
